import * as React from 'react'
import BaseIcon from '../../BaseIcon'

export default class CloudiaColoredIcon extends BaseIcon {
  getChildren = () => {
    const color = this.getColor() === 'currentColor' ? '#6568cd' : this.getColor()
    return [
      <g>
        <path
          fill={ color }
          d="M2,10.82V25.18a3.79,3.79,0,0,0,1.92,3.26l12,7a4.13,4.13,0,0,0,4.16,0l12-7A3.79,3.79,0,0,0,34,25.18V10.82a3.79,3.79,0,0,0-1.92-3.26l-12-7a4.13,4.13,0,0,0-4.16,0l-12,7A3.79,3.79,0,0,0,2,10.82Z"/>
        <path fill={ '#fff' }
              d="M18,6.3a2.5,2.5,0,1,1-2.5,2.5A2.5,2.5,0,0,1,18,6.3m0-2a4.5,4.5,0,1,0,4.5,4.5A4.49,4.49,0,0,0,18,4.3Z"/>
        <circle fill={ '#fff' } cx="18" cy="29.8" r="2"/>
        <circle fill={ '#fff' } cx="27.9" cy="24.3" r="2"/>
        <circle fill={ '#fff' } cx="8.1" cy="24.3" r="2"/>
        <path fill={ '#fff' } d="M18,27a1.5,1.5,0,0,1-1.5-1.5V15.8a1.5,1.5,0,1,1,3,0v9.7A1.5,1.5,0,0,1,18,27Z"/>
        <path fill={ color } d="M18,14.8a1,1,0,0,1,1,1v9.7a1,1,0,0,1-2,0V15.8a1,1,0,0,1,1-1m0-1a2,2,0,0,0-2,2v9.7a2,2,0,0,0,4,0V15.8a2,2,0,0,0-2-2Z"/>
        <path fill={ '#fff' }
              d="M23.8,24.5a1.31,1.31,0,0,1-.44-.07A9.9,9.9,0,0,1,16.52,16a1.49,1.49,0,0,1,.27-1.12,1.51,1.51,0,0,1,1-.59l.23,0a1.48,1.48,0,0,1,1.48,1.27,6.94,6.94,0,0,0,4.76,6,1.5,1.5,0,0,1,1,1.88A1.48,1.48,0,0,1,23.8,24.5Z"/>
        <path fill={ color }
              d="M18,14.8a1,1,0,0,1,1,.85c.5,3.26,2.31,5.53,5.11,6.39a1,1,0,0,1,.66,1.26,1,1,0,0,1-1,.7,1,1,0,0,1-.3,0A9.45,9.45,0,0,1,17,16a1,1,0,0,1,.84-1.14H18m0-1h0l-.3,0A2,2,0,0,0,16,16.1a10.42,10.42,0,0,0,7.19,8.81,2,2,0,0,0,.59.09,2,2,0,0,0,.59-3.91A6.46,6.46,0,0,1,20,15.5a2,2,0,0,0-2-1.7Z"/>
        <path fill={ '#fff' }
              d="M12.2,24.5a1.48,1.48,0,0,1-1.43-1.05,1.5,1.5,0,0,1,1-1.88,6.94,6.94,0,0,0,4.76-6A1.48,1.48,0,0,1,18,14.3l.23,0A1.49,1.49,0,0,1,19.48,16a9.9,9.9,0,0,1-6.83,8.4A1.41,1.41,0,0,1,12.2,24.5Z"/>
        <path fill={ color }
              d="M18,14.8h.15A1,1,0,0,1,19,16a9.45,9.45,0,0,1-6.49,8,1,1,0,0,1-.3,0,1,1,0,0,1-1-.7A1,1,0,0,1,11.9,22c2.8-.86,4.61-3.13,5.11-6.39a1,1,0,0,1,1-.85m0-1h0a2,2,0,0,0-2,1.7,6.46,6.46,0,0,1-4.41,5.59A2,2,0,0,0,12.2,25a2,2,0,0,0,.59-.09A10.42,10.42,0,0,0,20,16.1a2,2,0,0,0-1.68-2.28l-.3,0Z"/>
      </g> ]

  }
  getViewBox = () => '0 0 36 36'
}
